import {
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { totalPrice } from "../purchase/purFunction";
export default function SalaryComponentCard({
  index,
  item,
  arr,
  setFormData,
  value,
}) {
  console.log("item ", item);
  return (
    <Card
      sx={{
        mt: "10px",
        cursor: "pointer",
        boxShadow: "none",
        borderRadius: "0",
        borderBottom: "1px solid",
      }}
    >
      <CardContent
        sx={{
          p: "0px !important",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Grid container xs={12} sx={{ paddingLeft: "50px" }}>
          <Grid item xs={10}>
            <Grid container>
              <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  sx={{
                    fontSize: "15px",
                    // overflow: "Hidden",
                    // textOverflow: "ellipsis",
                    display: "-webkit-box",
                    "-webkit-line-clamp": "1",
                    "-webkit-box-orient": "vertical",
                  }}
                >
                  {value == "SalaryComponents"
                    ? item?.componentName
                    : value == "incentive"
                    ? item?.incentiveName
                    : value == "Deductions"
                    ? item?.componentName
                    : value == "otherAllowence"
                    ? item?.allowanceName
                    : ""}
                </Typography>
              </Grid>
              <Grid
                item
                xs={6}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  paddingX: "10px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "15px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {item?.amount ? (
                    <>
                      <CurrencyRupeeIcon
                        sx={{ fontSize: "15px", color: "black" }}
                      />
                      {item.amount}
                    </>
                  ) : item?.percentage ? (
                    <><span style={{marginRight:"8px", font:"bold"}}>%</span>{item.percentage}</>
                  ) : null}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={2}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <Typography
              sx={{
                fontSize: "15px",
                overflow: "Hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
              }}
            >
              <DeleteIcon
                onClick={() => {
                  let arr1 = [...arr.componentDetails];
                  arr1.splice(index, 1);

                  setFormData({
                    ...arr,
                    componentDetails: arr1,
                  });
                }}
              />
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
